import * as turf from '@turf/turf';

export default function getCentroid(polygon) {
    let centroid = turf.centroid(polygon);
    return ({lng: centroid.geometry.coordinates[0], lat: centroid.geometry.coordinates[1]})
}